
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    productproductSpecStockRecordPageList
  } from '@/api/supplier';
	import {
    getSearchDate,
		nextDay
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private keywords = ''
    private remarks = ''
    private type = null
    private typelist = [
      {value:null,label:'全部'},
      {value:0,label:'入库'},
      {value:1,label:'出库'},
      {value:2,label:'提交订单'},
      {value:3,label:'取消订单'},
      {value:4,label:'申请换货'},
      {value:5,label:'撤销换货申请'},
    ]
    private filterTime = [getSearchDate(2,false,-2)[0],getSearchDate(2)[0]].join('/')
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
		private pageSize = 100;
		private total = 0;

    private mounted () {
      this.gettablelist()
    }

    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.type = null
      this.remarks = ''
      this.filterTime = [getSearchDate(2,false,-2)[0],getSearchDate(2)[0]].join('/')
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          RemakKeywords:this.remarks,
          RecordType:this.type,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        if (this.filterTime){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await productproductSpecStockRecordPageList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
